'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var BUTTON_SIZES = ['md', 'sm'];
var BUTTON_TYPES = ['primary', 'secondary', 'link', 'link-text', 'link-cancel', 'link-delete'];

var Button = (function (_React$Component) {
    _inherits(Button, _React$Component);

    function Button() {
        _classCallCheck(this, Button);

        _get(Object.getPrototypeOf(Button.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Button, [{
        key: 'focus',
        value: function focus() {
            _reactDom2['default'].findDOMNode(this.refs.button).focus();
        }
    }, {
        key: 'render',
        value: function render() {
            // classes
            var componentClass = (0, _classnames2['default'])('Button', 'Button--' + this.props.type, this.props.size ? 'Button--' + this.props.size : null, {
                'Button--block': this.props.block,
                active: this.props.isActive
            }, this.props.className);

            // props
            var props = (0, _blacklist2['default'])(this.props, 'type', 'size', 'component', 'className', 'submit');
            props.className = componentClass;

            if (this.props.component) {
                return _react2['default'].cloneElement(this.props.component, props);
            }

            var tag = 'button';
            props.type = this.props.submit ? 'submit' : 'button';

            if (props.href) {
                tag = 'a';
                delete props.type;
            }

            return _react2['default'].createElement(tag, props, this.props.children);
        }
    }]);

    return Button;
})(_react2['default'].Component);

Button.propTypes = {
    block: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].string]),
    className: _propTypes2['default'].string,
    component: _propTypes2['default'].node,
    href: _propTypes2['default'].string,
    isActive: _propTypes2['default'].bool,
    size: _propTypes2['default'].oneOf(BUTTON_SIZES),
    submit: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].string]),
    type: _propTypes2['default'].oneOf(BUTTON_TYPES)
};

Button.defaultProps = {
    type: 'primary'
};

module.exports = Button;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Button.js
// module id = 274
// module chunks = 0